
        import { graphService } from './graph-service.js';
        import { authService } from './auth-service.js';

        // Wrap everything in an IIFE to prevent global scope pollution
        (async function() {
            try {
                // State management
                let allMembers = [];
                let currentPage = 1;
                let isLoading = false;
                let hasMore = true;
                let filters = {
                    departments: new Set()
                };
                let pinnedContacts = new Set(JSON.parse(localStorage.getItem('pinnedContacts') || '[]'));
                let lastLoadTime = new Date().getTime();
                let sortState = {
                    name: null,
                    department: null
                };

                // Add event listener for background updates
                window.addEventListener('contactsUpdated', (event) => {
                    const newData = event.detail;
                    allMembers = newData.members;
                    contactCount.textContent = `${newData.totalCount} contacts`;
                    populateFilterOptions();
                    updatePinnedContacts();
                    renderMembers(filterMembers(searchInput.value));
                });

                // Function to update theme
                function updateTheme(isDark) {
                    document.documentElement.classList.toggle('dark', isDark);
                    localStorage.setItem('theme', isDark ? 'dark' : 'light');
                }

                function toggleDarkMode() {
                    const isDark = !document.documentElement.classList.contains('dark');
                    updateTheme(isDark);
                }

                // Initial theme setup
                const isDarkMode = localStorage.theme === 'dark' || 
                    (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches);
                updateTheme(isDarkMode);

                // Dark mode toggle functionality
                const darkModeToggle = document.getElementById('darkModeToggle');
                const memberList = document.getElementById('memberList');
                const contactCount = document.getElementById('contactCount');
                const searchInput = document.getElementById('searchInput');

                darkModeToggle.addEventListener('click', toggleDarkMode);

                // Listen for system theme changes
                window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
                    if (!('theme' in localStorage)) {
                        updateTheme(e.matches);
                    }
                });

                // Function to update filters
                function updateFilters() {
                    const selectedDepartments = Array.from(document.querySelectorAll('input[name="department"]:checked')).map(input => input.value);
                    filters.departments = new Set(selectedDepartments);
                    
                    // Update selected filters display
                    updateSelectedFiltersDisplay();
                    
                    // Re-render members with current filters
                    renderMembers(filterMembers(searchInput.value));
                }

                // Function to update selected filters display
                function updateSelectedFiltersDisplay() {
                    const selectedFiltersContainer = document.getElementById('selectedFilters');
                    selectedFiltersContainer.innerHTML = '';
                    
                    filters.departments.forEach(dept => {
                        const filteredCount = allMembers.filter(member => member.department === dept).length;
                        selectedFiltersContainer.appendChild(createFilterTag('Department', dept, 'department', filteredCount));
                    });
                }

                // Function to create filter tag
                function createFilterTag(label, value, type, count) {
                    const tag = document.createElement('span');
                    tag.className = 'inline-flex items-center gap-1 rounded-full bg-blue-50 dark:bg-blue-900/30 px-2 py-1 text-xs font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-600/20 dark:ring-blue-500/20';
                    tag.innerHTML = `
                        ${label}: ${value} (${count})
                        <button type="button" class="group relative inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-blue-400 hover:bg-blue-500 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
                            <span class="sr-only">Remove ${label} filter</span>
                            <svg class="h-3 w-3" viewBox="0 0 16 16" fill="currentColor">
                                <path d="M4.646 4.646a.5.5 0 01.708 0L8 7.293l2.646-2.647a.5.5 0 01.708.708L8.707 8l2.647 2.646a.5.5 0 01-.708.708L8 8.707l-2.646 2.647a.5.5 0 01-.708-.708L7.293 8 4.646 5.354a.5.5 0 010-.708z"/>
                            </svg>
                        </button>
                    `;
                    
                    // Add click handler for the tag itself (excluding the remove button)
                    tag.addEventListener('click', (e) => {
                        // Don't trigger if clicking the remove button
                        if (e.target.closest('button')) return;
                        
                        if (type === 'department') {
                            // Update filters to only include this department
                            filters.departments = new Set([value]);
                            
                            // Update checkboxes in the filter dropdown
                            document.querySelectorAll('input[name="department"]').forEach(checkbox => {
                                checkbox.checked = checkbox.value === value;
                            });
                            
                            // Update selected filters display
                            updateSelectedFiltersDisplay();
                            
                            // Re-render members with the new filter
                            renderMembers(filterMembers(searchInput.value));
                        }
                    });
                    
                    // Add click handler for the remove button
                    tag.querySelector('button').addEventListener('click', (e) => {
                        e.stopPropagation();
                        if (type === 'department') {
                            filters.departments.delete(value);
                            // Update the checkbox in the dropdown
                            const checkbox = document.querySelector(`input[name="department"][value="${value}"]`);
                            if (checkbox) checkbox.checked = false;
                        }
                        updateSelectedFiltersDisplay();
                        renderMembers(filterMembers(searchInput.value));
                    });
                    
                    return tag;
                }

                // Function to populate filter options
                function populateFilterOptions() {
                    const departments = new Set();
                    
                    allMembers.forEach(member => {
                        if (member.department) departments.add(member.department);
                    });
                    
                    const filterDropdown = document.querySelector('#filterDropdown .space-y-2');
                    
                    // Clear existing options except the first one
                    while (filterDropdown.children.length > 1) filterDropdown.removeChild(filterDropdown.children[1]);
                    
                    // Add new options with counts
                    departments.forEach(dept => {
                        const count = allMembers.filter(member => member.department === dept).length;
                        const label = document.createElement('label');
                        label.className = 'flex items-center space-x-2';
                        label.innerHTML = `
                            <input type="checkbox" name="department" value="${dept}" class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 dark:border-gray-600 dark:bg-gray-700">
                            <span class="text-sm text-gray-700 dark:text-gray-300">${dept} (${count})</span>
                        `;
                        filterDropdown.appendChild(label);
                    });

                    // Add event listeners to checkboxes
                    filterDropdown.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                        checkbox.addEventListener('change', updateFilters);
                    });
                }

                // Function to render members
                async function renderMembers(members, targetElement = memberList) {
                    const memberElements = await Promise.all(members.map(async (member, index) => {
                        const isEvenRow = index % 2 === 0;
                        const avatarUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(member.displayName)}&background=random`;

                        return `
                        <li class="flex flex-col sm:flex-row justify-between gap-x-6 py-3 px-4 sm:px-6 ${isEvenRow ? 'bg-white dark:bg-gray-800' : 'bg-gray-100 dark:bg-gray-700'}" data-member-id="${member.id}">
                            <div class="flex min-w-0 gap-x-4">
                                <div class="relative">
                                    <div class="h-12 w-12 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse"></div>
                                    <img class="h-12 w-12 rounded-full bg-gray-50 object-cover absolute inset-0 opacity-0 transition-opacity duration-200" 
                                        src="${avatarUrl}" 
                                        alt="${member.displayName}"
                                        loading="lazy"
                                        onload="this.classList.remove('opacity-0')"
                                        onerror="this.src='${avatarUrl}'">
                                </div>
                                <div class="min-w-0 flex-auto">
                                    <div class="flex items-center gap-2">
                                        <p class="text-sm font-semibold leading-5 text-gray-900 dark:text-white truncate">${member.displayName}</p>
                                        <button class="pin-btn p-1.5 rounded-md ${pinnedContacts.has(member.id) ? 'text-blue-500' : 'text-gray-400'} hover:text-blue-500 dark:hover:text-blue-400 transition-colors duration-200" 
                                                data-member-id="${member.id}"
                                                title="Pin contact">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-4 h-4">
                                                <path d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div class="flex flex-wrap items-center gap-2 mt-0.5">
                                        <p class="text-sm leading-5 text-gray-500 dark:text-gray-400">${member.jobTitle || 'No Title'}</p>
                                        <div class="hidden sm:block h-4 w-px bg-gray-300 dark:bg-gray-600"></div>
                                        <span class="inline-flex items-center rounded-full bg-blue-50 dark:bg-blue-900/30 px-2 py-0.5 text-xs font-medium text-blue-700 dark:text-blue-300 ring-1 ring-inset ring-blue-600/20 dark:ring-blue-500/20 cursor-pointer hover:bg-blue-100 dark:hover:bg-blue-900/50 department-badge" 
                                              data-department="${member.department || 'No Department'}"
                                              title="Click to filter by department">${member.department || 'No Department'}</span>
                                    </div>
                                    <div class="mt-1.5 flex flex-col sm:flex-row sm:gap-x-4">
                                        <p class="text-xs leading-5 text-gray-500 dark:text-gray-400 flex items-center cursor-pointer hover:text-gray-700 dark:hover:text-gray-300 copyable-text" 
                                           data-text="${member.mail}" 
                                           title="Click to copy">
                                            <svg class="h-4 w-4 mr-1 text-gray-400 dark:text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                                <path d="M3 4a2 2 0 00-2 2v1.161l8.441 4.221a1.25 1.25 0 001.118 0L19 7.162V6a2 2 0 00-2-2H3z" />
                                                <path d="M19 8.839l-7.77 3.885a2.75 2.75 0 01-2.46 0L1 8.839V14a2 2 0 002 2h14a2 2 0 002-2V8.839z" />
                                            </svg>
                                            ${member.mail || 'No email'}
                                        </p>
                                        ${member.mobilePhone ? `
                                        <p class="text-xs leading-5 text-gray-500 dark:text-gray-400 flex items-center cursor-pointer hover:text-gray-700 dark:hover:text-gray-300 copyable-text" 
                                           data-text="${member.mobilePhone}" 
                                           title="Click to copy">
                                            <svg class="h-4 w-4 mr-1 text-gray-400 dark:text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                                <path d="M7 2a2 2 0 00-2 2v12a2 2 0 002 2h6a2 2 0 002-2V4a2 2 0 00-2-2H7zm3 14a1 1 0 100-2 1 1 0 000 2z" />
                                            </svg>
                                            ${member.mobilePhone}
                                        </p>
                                        ` : ''}
                                        ${member.businessPhones && member.businessPhones.length > 0 ? `
                                        <p class="text-xs leading-5 text-gray-500 dark:text-gray-400 flex items-center cursor-pointer hover:text-gray-700 dark:hover:text-gray-300 copyable-text" 
                                           data-text="${member.businessPhones[0]}" 
                                           title="Click to copy">
                                            <svg class="h-4 w-4 mr-1 text-gray-400 dark:text-gray-500" viewBox="0 0 20 20" fill="currentColor">
                                                <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                                <path d="M16.707 3.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" />
                                            </svg>
                                            ${member.businessPhones[0]}
                                        </p>
                                        ` : ''}
                                    </div>
                                </div>
                            </div>
                        </li>
                        `;
                    }));

                    targetElement.innerHTML = memberElements.join('');

                    // Add event listeners for department badges
                    targetElement.querySelectorAll('.department-badge').forEach(badge => {
                        badge.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const department = badge.getAttribute('data-department');
                            
                            // Update filters
                            filters.departments = new Set([department]);
                            
                            // Update checkboxes in the filter dropdown
                            document.querySelectorAll('input[name="department"]').forEach(checkbox => {
                                checkbox.checked = checkbox.value === department;
                            });
                            
                            // Update selected filters display
                            updateSelectedFiltersDisplay();
                            
                            // Re-render members with the new filter
                            renderMembers(filterMembers(searchInput.value));
                        });
                    });

                    // Load profile photos in the background with debouncing
                    const loadPhotos = async () => {
                        const batchSize = 5; // Process 5 photos at a time
                        for (let i = 0; i < members.length; i += batchSize) {
                            const batch = members.slice(i, i + batchSize);
                            await Promise.all(batch.map(async (member) => {
                                const photoUrl = await graphService.getUserPhoto(member.id);
                                if (photoUrl) {
                                    const img = targetElement.querySelector(`[data-member-id="${member.id}"] img`);
                                    if (img) {
                                        img.src = photoUrl;
                                    }
                                }
                            }));
                            // Add a small delay between batches to prevent overwhelming the API
                            await new Promise(resolve => setTimeout(resolve, 100));
                        }
                    };

                    // Start loading photos in the background
                    loadPhotos().catch(console.error);

                    // Add event listeners for pin buttons
                    targetElement.querySelectorAll('.pin-btn').forEach(btn => {
                        btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            const memberId = btn.getAttribute('data-member-id');
                            togglePin(memberId);
                        });
                    });
                }

                // Function to toggle pin
                function togglePin(memberId) {
                    if (pinnedContacts.has(memberId)) {
                        pinnedContacts.delete(memberId);
                    } else {
                        pinnedContacts.add(memberId);
                    }
                    savePreferences();

                    // Update pin button in the main list
                    const pinBtn = document.querySelector(`.pin-btn[data-member-id="${memberId}"]`);
                    if (pinBtn) {
                        pinBtn.classList.toggle('text-blue-500', pinnedContacts.has(memberId));
                        pinBtn.classList.toggle('text-gray-400', !pinnedContacts.has(memberId));
                    }

                    // Update pinned contacts section
                    updatePinnedContacts();
                }

                // Function to update pinned contacts section
                function updatePinnedContacts() {
                    const pinnedSection = document.getElementById('pinnedContacts');
                    const pinnedList = document.getElementById('pinnedList');
                    
                    if (pinnedContacts.size > 0) {
                        pinnedSection.classList.remove('hidden');
                        const pinnedMembers = allMembers.filter(member => pinnedContacts.has(member.id));
                        renderMembers(pinnedMembers, pinnedList);
                    } else {
                        pinnedSection.classList.add('hidden');
                    }
                }

                // Function to filter members
                function filterMembers(searchTerm) {
                    let filteredMembers = allMembers;
                    
                    // Apply search filter
                    if (searchTerm) {
                        const term = searchTerm.toLowerCase();
                        filteredMembers = filteredMembers.filter(member => 
                            member.displayName.toLowerCase().includes(term) ||
                            member.jobTitle?.toLowerCase().includes(term) ||
                            member.department?.toLowerCase().includes(term) ||
                            member.mail?.toLowerCase().includes(term)
                        );
                    }
                    
                    // Apply department filter
                    if (filters.departments.size > 0) {
                        filteredMembers = filteredMembers.filter(member => 
                            filters.departments.has(member.department)
                        );
                    }
                    
                    return filteredMembers;
                }

                // Function to sort members
                function sortMembers(members, sortBy) {
                    if (!sortBy) return members;
                    
                    return [...members].sort((a, b) => {
                        const aValue = sortBy === 'name' ? a.displayName : a.department || '';
                        const bValue = sortBy === 'name' ? b.displayName : b.department || '';
                        const direction = sortState[sortBy] === 'desc' ? -1 : 1;
                        return aValue.localeCompare(bValue) * direction;
                    });
                }

                // Function to update sort icons
                function updateSortIcons() {
                    const sortButton = document.getElementById('sortButton');
                    const sortDropdown = document.getElementById('sortDropdown');
                    const sortNameButton = document.getElementById('sortName');
                    const sortDepartmentButton = document.getElementById('sortDepartment');
                    const nameIcon = sortNameButton.querySelector('svg');
                    const departmentIcon = sortDepartmentButton.querySelector('svg');
                    
                    // Reset both icons
                    nameIcon.style.transform = '';
                    departmentIcon.style.transform = '';
                    
                    // Update name button and icon
                    if (sortState.name) {
                        nameIcon.style.transform = sortState.name === 'desc' ? 'rotate(180deg)' : '';
                        sortNameButton.classList.add('text-blue-600', 'dark:text-blue-400');
                    } else {
                        sortNameButton.classList.remove('text-blue-600', 'dark:text-blue-400');
                    }
                    
                    // Update department button and icon
                    if (sortState.department) {
                        departmentIcon.style.transform = sortState.department === 'desc' ? 'rotate(180deg)' : '';
                        sortDepartmentButton.classList.add('text-blue-600', 'dark:text-blue-400');
                    } else {
                        sortDepartmentButton.classList.remove('text-blue-600', 'dark:text-blue-400');
                    }

                    // Update sort button text and icon
                    const sortButtonText = sortButton.querySelector('span');
                    const sortButtonIcon = sortButton.querySelector('svg:last-child');
                    
                    if (sortState.name || sortState.department) {
                        const sortType = sortState.name ? 'Name' : 'Department';
                        const sortDirection = sortState.name ? sortState.name : sortState.department;
                        sortButtonText.textContent = `Sort by ${sortType} ${sortDirection === 'desc' ? '↓' : '↑'}`;
                        sortButtonIcon.style.transform = sortDirection === 'desc' ? 'rotate(180deg)' : '';
                        sortButton.classList.add('text-blue-600', 'dark:text-blue-400');
                    } else {
                        sortButtonText.textContent = 'Sort';
                        sortButtonIcon.style.transform = '';
                        sortButton.classList.remove('text-blue-600', 'dark:text-blue-400');
                    }
                }

                // Update loadMembers function
                async function loadMembers() {
                    if (isLoading) return;
                    
                    try {
                        isLoading = true;
                        document.getElementById('loadingIndicator').classList.remove('hidden');

                        const data = await graphService.getGroupMembers();
                        if (!data) {
                            return;
                        }

                        contactCount.textContent = `${data.totalCount} contacts`;
                        allMembers = data.members;

                        populateFilterOptions();
                        updatePinnedContacts();
                        renderMembers(filterMembers(searchInput.value));
                    } catch (error) {
                        console.error('Error loading members:', error);
                        alert('Failed to load team members. Please try again.');
                    } finally {
                        isLoading = false;
                        document.getElementById('loadingIndicator').classList.add('hidden');
                    }
                }

                // Search functionality
                let searchTimeout;
                searchInput.addEventListener('input', (e) => {
                    clearTimeout(searchTimeout);
                    searchTimeout = setTimeout(() => {
                        renderMembers(filterMembers(e.target.value));
                    }, 300);
                });

                // Login button functionality
                const loginButton = document.getElementById('loginButton');

                loginButton.addEventListener('click', async () => {
                    try {
                        console.log('Login button clicked');
                        await authService.login();
                        console.log('Login successful');
                        // After successful login, load user info and members
                        await loadUserInfo();
                        await loadMembers();
                    } catch (error) {
                        console.error('Login failed:', error);
                        alert('Failed to sign in. Please try again.');
                    }
                });

                // Function to load user info
                async function loadUserInfo() {
                    try {
                        console.log('Loading user info...');
                        const user = await graphService.getUserProfile();
                        console.log('User profile:', user);
                        if (user) {
                            const userPhoto = await graphService.getUserPhoto(user.id);
                            console.log('User photo URL:', userPhoto);
                            const userInfo = document.getElementById('userInfo');
                            const userPhotoElement = document.getElementById('userPhoto');
                            const userNameElement = document.getElementById('userName');
                            const loginButton = document.getElementById('loginButton');
                            const logoutButton = document.getElementById('logoutButton');
                            const welcomeMessage = document.getElementById('welcomeMessage');
                            
                            // Add loading state for user photo
                            userPhotoElement.style.opacity = '0';
                            userPhotoElement.src = userPhoto || `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName)}&background=random`;
                            userPhotoElement.onload = () => {
                                userPhotoElement.style.opacity = '1';
                            };
                            userPhotoElement.onerror = () => {
                                userPhotoElement.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(user.displayName)}&background=random`;
                            };
                            
                            userNameElement.textContent = user.displayName;
                            userInfo.classList.remove('hidden');
                            userInfo.classList.add('flex', 'items-center', 'space-x-2');
                            loginButton.classList.add('hidden');
                            logoutButton.classList.remove('hidden');
                            welcomeMessage.classList.add('hidden');
                            console.log('User info displayed');
                        }
                    } catch (error) {
                        console.error('Error loading user info:', error);
                    }
                }

                // Logout button functionality
                const logoutButton = document.getElementById('logoutButton');
                logoutButton.addEventListener('click', async () => {
                    try {
                        await authService.logout();
                        const userInfo = document.getElementById('userInfo');
                        const loginButton = document.getElementById('loginButton');
                        const logoutButton = document.getElementById('logoutButton');
                        const welcomeMessage = document.getElementById('welcomeMessage');
                        userInfo.classList.add('hidden');
                        loginButton.classList.remove('hidden');
                        logoutButton.classList.add('hidden');
                        welcomeMessage.classList.remove('hidden');
                        // Clear the member list
                        memberList.innerHTML = '';
                        allMembers = [];
                        currentPage = 1;
                        hasMore = true;
                        contactCount.textContent = 'Loading contacts...';
                    } catch (error) {
                        console.error('Logout failed:', error);
                        alert('Failed to sign out. Please try again.');
                    }
                });

                // Initialize the application
                try {
                    console.log('Starting application initialization...');
                    await authService.initialize();
                    console.log('Auth initialized, checking if authenticated...');
                    
                    // Add a small delay to ensure auth state is properly set
                    await new Promise(resolve => setTimeout(resolve, 100));
                    
                    if (authService.isAuthenticated()) {
                        console.log('User is authenticated, loading info...');
                        await loadUserInfo();
                        console.log('User info loaded, loading members...');
                        await loadMembers();
                    } else {
                        console.log('User is not authenticated, showing login button');
                        const loginButton = document.getElementById('loginButton');
                        const logoutButton = document.getElementById('logoutButton');
                        const welcomeMessage = document.getElementById('welcomeMessage');
                        loginButton.classList.remove('hidden');
                        logoutButton.classList.add('hidden');
                        welcomeMessage.classList.remove('hidden');
                    }
                } catch (error) {
                    console.error('Error during initialization:', error);
                    // Show error state to user
                    const loginButton = document.getElementById('loginButton');
                    const logoutButton = document.getElementById('logoutButton');
                    const welcomeMessage = document.getElementById('welcomeMessage');
                    loginButton.classList.remove('hidden');
                    logoutButton.classList.add('hidden');
                    welcomeMessage.classList.remove('hidden');
                    welcomeMessage.querySelector('p').textContent = 'Error loading contacts. Please try refreshing the page.';
                }

                // Add event listeners for copyable text
                document.addEventListener('click', function(event) {
                    const copyableText = event.target.closest('.copyable-text');
                    if (copyableText) {
                        const text = copyableText.getAttribute('data-text');
                        if (text && text !== 'No email') {
                            copyToClipboard(text, copyableText);
                        }
                    }
                });

                // Update copy to clipboard function
                window.copyToClipboard = async function(text, element) {
                    if (!text || text === 'No email') return; // Don't copy placeholder text
                    
                    try {
                        await navigator.clipboard.writeText(text);
                        // Show toast notification
                        const toast = document.getElementById('copyToast');
                        toast.classList.remove('translate-y-full', 'opacity-0');
                        setTimeout(() => {
                            toast.classList.add('translate-y-full', 'opacity-0');
                        }, 2000);
                    } catch (err) {
                        console.error('Failed to copy text: ', err);
                        alert('Failed to copy text to clipboard');
                    }
                };

                // Function to save preferences
                function savePreferences() {
                    localStorage.setItem('pinnedContacts', JSON.stringify(Array.from(pinnedContacts)));
                }

                // Add filter button click handler
                const filterButton = document.getElementById('filterButton');
                const filterDropdown = document.getElementById('filterDropdown');

                filterButton.addEventListener('click', () => {
                    filterDropdown.classList.toggle('hidden');
                });

                // Close dropdown when clicking outside
                document.addEventListener('click', (e) => {
                    if (!filterButton.contains(e.target) && !filterDropdown.contains(e.target)) {
                        filterDropdown.classList.add('hidden');
                    }
                });

                // Sort button click handler
                document.getElementById('sortButton').addEventListener('click', () => {
                    const sortDropdown = document.getElementById('sortDropdown');
                    sortDropdown.classList.toggle('hidden');
                });

                // Close dropdown when clicking outside
                document.addEventListener('click', (e) => {
                    const sortButton = document.getElementById('sortButton');
                    const sortDropdown = document.getElementById('sortDropdown');
                    if (!sortButton.contains(e.target) && !sortDropdown.contains(e.target)) {
                        sortDropdown.classList.add('hidden');
                    }
                });

                // Sort by name handler
                document.getElementById('sortName').addEventListener('click', () => {
                    if (sortState.name === 'asc') {
                        sortState.name = 'desc';
                    } else if (sortState.name === 'desc') {
                        sortState.name = 'asc';
                    } else {
                        sortState.name = 'asc';
                    }
                    sortState.department = null;
                    updateSortIcons();
                    renderMembers(sortMembers(filterMembers(searchInput.value), 'name'));
                    document.getElementById('sortDropdown').classList.add('hidden');
                });

                // Sort by department handler
                document.getElementById('sortDepartment').addEventListener('click', () => {
                    if (sortState.department === 'asc') {
                        sortState.department = 'desc';
                    } else if (sortState.department === 'desc') {
                        sortState.department = 'asc';
                    } else {
                        sortState.department = 'asc';
                    }
                    sortState.name = null;
                    updateSortIcons();
                    renderMembers(sortMembers(filterMembers(searchInput.value), 'department'));
                    document.getElementById('sortDropdown').classList.add('hidden');
                });

                // Add clear sort handler
                document.getElementById('clearSort').addEventListener('click', () => {
                    sortState.name = null;
                    sortState.department = null;
                    updateSortIcons();
                    renderMembers(filterMembers(searchInput.value));
                    document.getElementById('sortDropdown').classList.add('hidden');
                });
            } catch (error) {
                console.error('Error initializing application:', error);
            }
        })();
    